import React from "react";
import { Team } from "../../../types";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { AlignmentColumns } from "../Columns";
import { GridSectionHeader } from "../GridHeaderFactory";

interface AnalysisObject {
  id: number;
  section: string;
  analyses: {
    id: number;
    section: string;
    question: string;
    user: string;
    self: number | undefined;
    peers: number | undefined;
    gap: number | undefined;
  }[];
  aggregates: {
    id: number;
    section: string;
    question: string;
    comments: {
      recipient: string;
      respondent: string;
      id?: string;
      comment: string;
      team?: Team;
      timestamp?: Date;
    }[];
  }[];
}

export default function InsightSummaryBlock({
  analysisObjects,
}: { analysisObjects: AnalysisObject[] }) {
  function sectionAverage(
    analyses: {
      id: number;
      section: string;
      question: string;
      user: string;
      self: number | undefined;
      peers: number | undefined;
      gap: number | undefined;
    }[],
  ) {
    const alignments = analyses
      .filter((analysis) => analysis && Number.isFinite(analysis.gap))
      .map(
        (analysis) =>
          analysis !== undefined &&
          analysis.gap !== undefined &&
          analysis.self !== undefined &&
          1 + analysis?.gap / analysis?.self,
      ) as number[];
    return (
      alignments.reduce(
        (a, b) => (a !== undefined && b !== undefined ? a + b : 0),
        0,
      ) / alignments.length
    );
  }

  const alignmentBySection = analysisObjects.map((sectionObject) => ({
    id: sectionObject.id,
    section: analysisObjects.length > 1 ? sectionObject.section : "Overall",
    alignment: sectionAverage(sectionObject.analyses),
  }));

  return (
    <Box>
      <GridSectionHeader title="Average Alignment by Section" />
      <DataGrid
        autoHeight={true}
        initialState={{
          sorting: {
            sortModel: [{ field: "alignment", sort: "desc" }],
          },
        }}
        hideFooter={true}
        rows={alignmentBySection}
        sx={{ backgroundColor: "black", mb: 1 }}
        columns={AlignmentColumns}
        pagination={undefined}
        getRowHeight={() => "auto"}
      />
    </Box>
  );
}
